import React from 'react';
import { SvgProps } from 'models/Icon';

export default (props: SvgProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M7.91393 11.7129L12.3137 18.6268L17.9706 1.65625L1 7.3131L7.91393 11.7129ZM7.91393 11.7129L12.9422 6.68456" />
  </svg>
);
